// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3TicD","bigColWidth":"Table_bigColWidth__3-Hez","biggerColWidth":"Table_biggerColWidth__318EH","row":"Table_row__1mIY_","col":"Table_col__1l2Qf"};